import { Controller } from "@hotwired/stimulus"

// The same day `years` on, as an <input type=date> value; 29 February
// becomes 28 February in a year without one.
export function yearsFrom(today, years) {
  const year = today.getFullYear() + years
  const month = today.getMonth()
  const day = Math.min(today.getDate(), new Date(year, month + 1, 0).getDate())
  const pad = (n) => String(n).padStart(2, "0")
  return `${year}-${pad(month + 1)}-${pad(day)}`
}

// Fills a date field with today plus N years and fires input and change, as
// typing would, for anything listening on the form.
export default class extends Controller {
  static targets = ["input"]

  set({ params: { years } }) {
    this.inputTarget.value = yearsFrom(new Date(), years)
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
